import { Section, Typography } from '@cmg/design-system';
import React from 'react';

import { ManageIndication_OfferingPartsFragment } from '../manage-indication/graphql/__generated__';

export type Props = {
  disclaimers: ManageIndication_OfferingPartsFragment['disclaimers'];
};

export const NoticesAndDisclaimers: React.FC<Props> = ({ disclaimers }) => {
  return (
    <Section title="Notices and Disclaimers" data-testid="notices-and-disclaimers-section">
      <Typography variant="body2" color="text.secondary" data-testid="notices-and-disclaimers-text">
        {disclaimers.rule134Legend ?? '-'}
      </Typography>
    </Section>
  );
};
